import {Button, ButtonProps} from 'antd';
import styles from './index.module.scss';
import classNames from 'classnames';

export function LinkButton({className, ...props}: ButtonProps) {
    return (
        <Button
            type="link"
            className={classNames(styles.root, className)}
            {...props}
        />
    );
}
